import { isNull, get } from "lodash"
import locales from "./../../../content.json";

import cross from './img/cross.png';
import facepalm from './img/facepalm.png';
import frowningFace from './img/frowning-face.png';
import thinking from './img/thinking.png';

export const checkIsValidCurrentActivity = data => {
    return validateCurrentStep(get(data, ["idealWeight", "value"], "")) && !data.idealWeight.isValid
}

export const validateCurrentStep = value => {
    return !isNull(value)
}

export const staticData = {
    0: {
        value: "<1",
        title: locales[window.userLang].ideal_weight_time_step_1,
        icon: thinking,
    },
    1: {
        value: "1-2",
        title: locales[window.userLang].ideal_weight_time_step_2,
        icon: frowningFace,
    },
    2: {
        value: "3+",
        title: locales[window.userLang].ideal_weight_time_step_3,
        icon: facepalm,
    },
    3: {
        value: "never",
        title: locales[window.userLang].ideal_weight_time_step_4,
        icon: cross,
    },
}